import Rollbar from 'rollbar';
import { APP_VERSION_ID, ROLLBAR_ENV, ROLLBAR_CLIENT_TOKEN } from '@/app/core/common/config';
import { isRollbarEnabled } from '@/app/core/utils/isRollbarEnabled';

export const RollbarService = isRollbarEnabled()
    ? new Rollbar({
          accessToken: ROLLBAR_CLIENT_TOKEN,
          captureUncaught: true,
          captureUnhandledRejections: true,
          payload: {
              environment: ROLLBAR_ENV,
              client: {
                  javascript: {
                      source_map_enabled: true,
                      code_version: APP_VERSION_ID,
                      guess_uncaught_frames: true,
                  },
              },
          },
      })
    : null;

export function setUser(user) {
    if (!RollbarService) {
        return;
    }

    const userData = user
        ? {
              id: user.id,
              username: user.full_name,
              email: user.email,
              group: user.group,
              role: user.role,
          }
        : null;

    RollbarService.configure({
        payload: {
            person: userData,
        },
    });
}
